import React, { useContext, useEffect, useRef, useState } from "react";
import { IconGeneric } from "styled/Icons.styled";
import { MdDelete, MdOutlineImage } from "react-icons/md";
import { RiUploadCloudFill } from "react-icons/ri";
import "../styleForm.css";
import { Tooltip, useDisclosure } from "@chakra-ui/react";
import { ButtonHeaderModule } from "styled/Buttons.styled";
import { NavLink, useLocation } from "react-router-dom";
import SpinnerComponent from "components/Spinner/SpinnerComponent";
import { Modalcustomizable } from "components/modal/ModalPass";
import ZoomImage from "components/DispatchCorrections/ZoomedImage";
import { isNumber, isString } from "utils/type-check-utils";
import GlobalContext, { useGlobalContext } from "context/GlobalContext";
import { FaEdit, FaRegEye } from "react-icons/fa";
import { useModal } from "hooks/useModal";
import { useForm } from "hooks/useForm";
import { ModalGeneric } from "components/modal/ModalGeneric";
import { GroupInputUpload } from "pages/Entry_and_exit_forms/GroupInputUpload";
import { useSelector } from "react-redux";
import Vapor from "laravel-vapor";
import environment from "constants/apiConst";
import Swal from "sweetalert2";


const extractId = (str) => {
  const match = str && str.match(/\d+/);
  return match ? parseInt(match[0]) : 0;
};

/**
 * DocumentUploader - Componente robusto para la carga de archivos.
 * Maneja el estado del archivo en memoria y coordina la subida a S3 (Vapor)
 * antes de confirmar la escritura en base de datos.
 */
const DocumentUploader = ({
  document: fileConfig,
  handleFiles,
  handleFilesInput,
  handleDelete,
  files,
  viewBtn = false,
  viewBtnDelete = true,
  loading,
  idFmm = 0,
  setAttachmentDescription = null,
  setAttachmentNumber = null,
  documentPreview = false,
  callBack = () => { },
  isLoading = false,
  accept = ".doc,.docx,image/png,image/*,.png,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,application/vnd.ms-excel",
}) => {
  // Identificador único y Hooks básicos
  const idFiles =
    isNumber(fileConfig?.doc_corrected_req) && fileConfig?.doc_corrected_req === 1
      ? `document-${fileConfig?.id}_doc_corrected_req`
      : `document-${fileConfig?.id}`;

  const location = useLocation();
  const { pathname } = location;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { IsTheFormLocked, setNameDocument } = useGlobalContext();
  const token = useSelector((state) => state.auth.dataUser.token); // Necesario para Vapor

  // Estado Local y Refs (Reemplaza localStorage y document.getElementById)
  const fileInputRef = useRef(null);
  const [tempFile, setTempFile] = useState(null); // Almacena el archivo crudo antes de subir
  const [previewImage, setPreviewImage] = useState(null);
  const [isUploadingLocal, setIsUploadingLocal] = useState(false);

  // Modal para metadata
  const [isOpenUpload, onOpenUpload, onCloseUpload] = useModal();

  // Formulario local para metadata (sin localStorage)
  const [valuesEdit, handleInputEdit, resetEdit, setValuesEdit] = useForm({
    index: null,
    attachment_description: "",
    attachment_number: "",
    attachment_comment: "",
    attachment_date: "",
  });

  // Manejo de Errores Visuales
  const obtenerError = JSON.parse(
    localStorage.getItem(`errorAttadchment-${idFmm}`) || "[]"
  );

  // Lógica de Previsualización
  const openImageView = (url, fileName = "") => {
    const getFileExtension = fileConfig?.name?.split(".").pop() || fileName?.split(".").pop();
    const fileExtension = isString(getFileExtension)
      ? getFileExtension.toLowerCase()
      : getFileExtension || "";

    if (["png", "jpg", "jpeg", "webp"].includes(fileExtension)) {
      return (
        <a
          href={url}
          id="downloadFile"
          onClick={(e) => {
            e.preventDefault();
            setPreviewImage(url);
            onOpen();
          }}
        >
          {files?.[idFiles]?.name}
        </a>
      );
    }

    return (
      <NavLink target="_blank" to={files[idFiles].downloadFile} className="ms-2">
        <span className="formNumber">{files?.[idFiles]?.name}</span>
      </NavLink>
    );
  };

  // Configuración de Edición
  const editAttachmentLocal = (index, nameDocument) => {
    const currentFile = files?.[index];
    setValuesEdit({
      index: currentFile?.originalIndex,
      id: currentFile?.id,
      url: currentFile?.downloadFile || "",
      name: currentFile?.name || currentFile?.other_attachment_name,
      attachment_description: currentFile?.attachment_description || "",
      attachment_number: currentFile?.attachment_number || "",
      attachment_comment: currentFile?.attachment_comment || "",
      attachment_date: currentFile?.attachment_date || "",
      nameDocument,
      ...currentFile,
    });
    setTempFile(null); // Si editamos, no hay archivo nuevo pendiente a menos que se suba uno
    onOpenUpload();
  };

  // Funciones de Disparo (Trigger)
  const handleTriggerClick = (e) => {
    // Evitamos el comportamiento por defecto y usamos la referencia
    e && e.preventDefault();
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Limpiar input para permitir seleccionar el mismo archivo
      fileInputRef.current.click();
    }
  };

  // Captura del Archivo (Paso 1 del Flujo)
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    // Guardamos el archivo en memoria y abrimos el modal para pedir datos
    setTempFile(selectedFile);
    setNameDocument(fileConfig?.name_document);

    // Preparamos el form del modal con datos vacíos o por defecto
    setValuesEdit({
      name: selectedFile.name,
      attachment_description: "",
      attachment_number: "",
      attachment_comment: "",
      attachment_date: new Date().toISOString().split('T')[0],
    });

    onOpenUpload();
  };

  // Proceso de Subida Atómico (Paso 2 del Flujo - Confirmación del Modal)
  const handleConfirmMetadata = async (metadataValues) => {
    // Si estamos editando y no hay archivo nuevo, solo pasamos la metadata
    if (!tempFile && valuesEdit.id) {
      callBack({ ...valuesEdit, ...metadataValues });
      onCloseUpload();
      return;
    }

    if (!tempFile) {
      onCloseUpload();
      return;
    }

    setIsUploadingLocal(true);

    try {
      // Subida a S3 via Vapor
      const response = await Vapor.store(tempFile, {
        baseURL: environment.VAPOR_BASE_URL,
        headers: { Authorization: `Bearer ${token}` },
      });

      // Construir payload completo (Archivo procesado + Metadata)
      const payload = {
        file: response, // Objeto con uuid, key, bucket, etc.
        name: tempFile.name,
        document_id: isNumber(fileConfig?.id) ? fileConfig?.id : extractId(idFiles),
        // Metadata del formulario
        attachment_description: metadataValues.attachment_description,
        attachment_number: metadataValues.attachment_number,
        attachment_date: metadataValues.attachment_date,
        attachment_comment: metadataValues.attachment_comment,
        // Flags
        doc_corrected_req: fileConfig?.doc_corrected_req
      };

      // Pasar al padre para guardar en BD
      // Simulamos un evento o pasamos el objeto directo.
      // Nota: El padre deberá ser actualizado para aceptar este objeto directo.
      const syntheticEvent = {
        target: {
          id: idFiles,
          name: fileConfig?.name_document,
          files: [tempFile] // Legacy support
        },
        payload: payload // Datos limpios para el padre refactorizado
      };

      await handleFilesInput(syntheticEvent);

      // Limpieza
      setTempFile(null);
      onCloseUpload();

    } catch (error) {
      console.error("Upload Error:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error en la carga',
        text: 'No se pudo cargar el archivo al servidor (S3). Por favor intente nuevamente.'
      });
    } finally {
      setIsUploadingLocal(false);
    }
  };

  const iconPreview = documentPreview ? FaRegEye : FaEdit;
  const textTooltipPreview = documentPreview ? `Ver ${valuesEdit.nameDocument}` : `Editar ${valuesEdit.nameDocument}`;

  return (
    <>
      {/* Modal de Carga / Edición */}
      <ModalGeneric
        isOpen={isOpenUpload}
        onClose={onCloseUpload}
        onOpen={onOpenUpload}
        title={tempFile ? `Cargar: ${tempFile.name}` : textTooltipPreview}
        size={"lg"}
      >
        <GroupInputUpload
          // Pasamos valores controlados, eliminando la dependencia interna de localStorage
          customHandleChange={{
            values: valuesEdit,
            handleInputChange: handleInputEdit,
            reset: resetEdit,
            setValues: setValuesEdit,
          }}
          // Interceptamos el callback para hacer la subida atómica
          callBack={handleConfirmMetadata}
          onClose={onCloseUpload}
          mode={tempFile ? "create" : "edit"} // Diferenciamos modo
          preview={documentPreview}
          isLoading={isUploadingLocal} // Pasar estado de carga al botón del modal
        />
      </ModalGeneric>

      {/* Modal de Previsualización de Imagen */}
      <Modalcustomizable
        title={"Previsualización"}
        isOpen={isOpen}
        onClose={onClose}
        rightButtonText={"Confirmar"}
        iconComponent={MdOutlineImage}
        hiddenButtons={true}
        size={"3xl"}
      >
        <ZoomImage src={previewImage} />
      </Modalcustomizable>

      {/* UI Principal */}
      <div className="row">
        <div className="col-6 mt-2">
          <h2>{fileConfig?.name_document}</h2>
        </div>

        <div className="col-4 mt-2">
          {/* Spinner de Carga Global o Local */}
          {(loading?.label && loading?.name === idFiles && !files[idFiles]) || isUploadingLocal ? (
            <SpinnerComponent />
          ) : null}

          {/* Botón de Carga (Si no hay archivo) */}
          {(!files[idFiles]) && !isUploadingLocal && (
            <Tooltip placement="top" hasArrow label="Agregar adjunto">
              <span>
                <ButtonHeaderModule
                  className={obtenerError && obtenerError.includes(fileConfig?.id) ? "border border-danger" : ""}
                  onClick={handleTriggerClick}
                  bgColor="#03C39A"
                  isLoading={isLoading || isUploadingLocal}
                >
                  <IconGeneric color="#fff" as={RiUploadCloudFill} />
                </ButtonHeaderModule>
              </span>
            </Tooltip>
          )}

          {/* Nombre o Link del archivo cargado */}
          {files?.[idFiles]?.from_server && (
            openImageView(files[idFiles].downloadFile, files[idFiles].name)
          )}

          {!files?.[idFiles]?.from_server && files?.[idFiles] && (
            <span>{files?.[idFiles]?.name}</span>
          )}
        </div>

        {/* Botones de Acción (Borrar / Editar) */}
        {!IsTheFormLocked && (
          <div className="col-1 mt-2">
            {files[idFiles] && viewBtnDelete && (
              <IconGeneric
                onClick={() => {
                  if (fileInputRef.current) fileInputRef.current.value = "";
                  handleDelete(
                    idFiles,
                    fileConfig?.name_document,
                    { ...files?.[idFiles], doc_corrected_req: fileConfig?.doc_corrected_req },
                    "UploaderFile"
                  );
                }}
                className="text-danger"
                as={MdDelete}
              />
            )}

            {files?.[idFiles]?.from_server && (
              <IconGeneric
                onClick={() => editAttachmentLocal(idFiles, fileConfig?.name_document)}
                color="#1F7AC3"
                as={iconPreview}
              />
            )}
          </div>
        )}

        {/* Input Oculto Controlado */}
        <input
          ref={fileInputRef}
          type="file"
          data-isCorrected={fileConfig?.doc_corrected_req}
          id={idFiles} // Mantenemos ID por compatibilidad CSS si la hay, pero la lógica va por Ref
          hidden
          accept={accept}
          onChange={handleFileChange}
          name={fileConfig?.name_document}
        />
      </div>
    </>
  );
};

export default DocumentUploader;